import { Card, Divider, Empty, message, Skeleton, Tabs, Button } from "antd";
import React, { useContext } from "react";
import { useParams } from "react-router-dom";
import { ChannelType } from "../../contexts/channels/ChannelProvider";
import {
    PaymentContext,
    PaymentContextProvider,
    PaymentContextType,
} from "../../contexts/payment/PaymentContext";
import { thousandSeparator } from "../../helpers/thousand_separator";
import { ChannelModel } from "../../models/ChannelModel";
import "./payment.css";
import axios from "axios";
import { CompanySingleResultInterface } from "../../models/CompanyModel";
import {
    BCAVAFlip,
    BNIVAFlip,
    BRIVAFlip,
    BSIVAFlip,
    CIMBVAFlip,
    DanaFlip,
    DanamonVAFlip,
    DokuFlip,
    GopayFlip,
    MandiriVAFlip,
    OvoFlip,
    PermataVAFlip,
    QrisFlip,
    SeabankVAFlip,
    ShopeeFlip,
} from "../../contexts/channels/interfaces/ry-flip.channel";

function PaymentRyFlipTopupV2() {
    return (
        <PaymentContextProvider>
            <PaymentRyFlipTopupV2State />
        </PaymentContextProvider>
    );
}

function PaymentRyFlipTopupV2State() {
    const [channel, setChannel] = React.useState<ChannelModel>();
    const {
        getWalletDetail,
        getWalletDetailStatus,
        walletDetail,
        walletDetailStatus,
        doPaymentFlipTopupV2,
        paymentResultRyFlip,
        loading,
    } = useContext<PaymentContextType>(PaymentContext);
    const params = useParams();

    React.useEffect(() => {
        if (params) {
            if (params["invoice_code"] !== undefined) {
                getWalletDetail(params["invoice_code"] as string);

                const interval = setInterval(() => {
                    getWalletDetailStatus(params["invoice_code"] as string);
                }, 5000);
                // Stop the interval when the component unmounts
                return () => clearInterval(interval);
            }
        }
    }, [params]);

    React.useEffect(() => {
        window.onpopstate = () => {
            const invoiceCode = params["invoice_code"] as string;
            if (invoiceCode) {
                axios.get(
                    `${process.env.REACT_APP_BASE_URL}/api/payment_ry_flip_cancel`,
                    { params: { partner_ref_number: invoiceCode } }
                );
            }
        };
    }, [params]);

    React.useEffect(() => {
        if (walletDetail !== undefined) {
            const paymentName = walletDetail?.data?.payment_name?.toLowerCase();
            const paymentId = walletDetail?.data?.payment_id;

            if (paymentName.includes("bca")) {
                setChannel({ id: paymentId, ...BCAVAFlip });
            } else if (paymentName.includes("mandiri")) {
                setChannel({ id: paymentId, ...MandiriVAFlip });
            } else if (paymentName.includes("bni")) {
                setChannel({ id: paymentId, ...BNIVAFlip });
            } else if (paymentName.includes("bri")) {
                setChannel({ id: paymentId, ...BRIVAFlip });
            } else if (paymentName.includes("bsi")) {
                setChannel({ id: paymentId, ...BSIVAFlip });
            } else if (paymentName.includes("cimb")) {
                setChannel({ id: paymentId, ...CIMBVAFlip });
            } else if (paymentName.includes("danamon")) {
                setChannel({ id: paymentId, ...DanamonVAFlip });
            } else if (paymentName.includes("permata")) {
                setChannel({ id: paymentId, ...PermataVAFlip });
            } else if (paymentName.includes("seabank")) {
                setChannel({ id: paymentId, ...SeabankVAFlip });
            } else if (paymentName.includes("ovo")) {
                setChannel({ id: paymentId, ...OvoFlip });
            } else if (paymentName.includes("gopay")) {
                setChannel({ id: paymentId, ...GopayFlip });
            } else if (paymentName.includes("dana")) {
                setChannel({ id: paymentId, ...DanaFlip });
            } else if (paymentName.includes("shopee")) {
                setChannel({ id: paymentId, ...ShopeeFlip });
            } else if (paymentName.includes("qris")) {
                setChannel({ id: paymentId, ...QrisFlip });
            } else if (paymentName.includes("doku")) {
                setChannel({ id: paymentId, ...DokuFlip });
            }
        }
    }, [walletDetail]);

    React.useEffect(() => {
        if (walletDetailStatus !== undefined) {
            if (
                walletDetailStatus?.data?.status === "settlement" ||
                walletDetailStatus?.data?.status === "capture"
            ) {
                axios
                    .get(
                        `${process.env.REACT_APP_MAIN_URL}/public/companies/${process.env.REACT_APP_COMPANY_ID}`
                    )
                    .then((res) => {
                        const response = res.data as CompanySingleResultInterface;
                        const url = `${response?.data?.platform_donation}/payment/success-topup?invoice_code=${walletDetailStatus?.data?.invoice_code}&result=success`;
                        window.location.href = url;
                    });
            } else if (
                walletDetailStatus?.data?.status === "cancel" ||
                walletDetailStatus?.data?.status === "deny"
            ) {
                axios
                    .get(
                        `${process.env.REACT_APP_MAIN_URL}/public/companies/${process.env.REACT_APP_COMPANY_ID}`
                    )
                    .then((res) => {
                        const response = res.data as CompanySingleResultInterface;
                        const url = `${response?.data?.platform_donation}/payment/failed-topup?invoice_code=${walletDetailStatus?.data?.invoice_code}&result=failed`;
                        window.location.href = url;
                    });
            } else if (walletDetailStatus?.data?.status === "expire") {
                axios
                    .get(
                        `${process.env.REACT_APP_MAIN_URL}/public/companies/${process.env.REACT_APP_COMPANY_ID}`
                    )
                    .then((res) => {
                        const response = res.data as CompanySingleResultInterface;
                        const url = `${response?.data?.platform_donation}/payment/timeout-topup?invoice_code=${walletDetailStatus?.data?.invoice_code}&result=expire`;
                        window.location.href = url;
                    });
            }
        }
    }, [walletDetailStatus]);

    React.useEffect(() => {
        if (walletDetail !== undefined && channel !== undefined) {
            doPaymentFlipTopupV2(channel);
        }
    }, [walletDetail, channel]);

    return (
        <div style={{ margin: 20 }}>
            <Skeleton loading={loading}>
                <h1>{channel?.title}</h1>
                <h2>{channel?.subtitle}</h2>

                {paymentResultRyFlip?.data?.data?.bank_type === 'wallet_account' && (
                    <Button
                        type="primary"
                        size={'large'}
                        style={{ marginBottom: 10, width: '100%' }}>
                        <a
                            href={paymentResultRyFlip?.data?.data?.payment_url}
                            target="_blank"
                            rel="noreferrer">
                            Bayar disini
                        </a>
                    </Button>
                )}

                {paymentResultRyFlip?.status && paymentResultRyFlip?.data?.success ? (
                    <>
                        <Card hoverable style={{ marginBottom: 10 }}>
                            <p className="amount">Jumlah</p>
                            <div style={{ float: "right" }}>
                                <span className="amount-rp">Rp </span>
                                <span className="amount-number">
                                    {thousandSeparator(walletDetail?.data?.amount ?? 0)}
                                </span>
                            </div>
                        </Card>

                        {channel?.type === ChannelType.VIRTUAL_ACCOUNT ? (
                            <Card style={{ marginBottom: 10 }}>
                                <div style={{ float: "left" }}>
                                    <span className="account-number-text-block">Nomor Rekening</span>
                                    <span className="account-number">
                                        {paymentResultRyFlip?.data?.data?.account_number}
                                    </span>
                                    <br />
                                    <a
                                        href="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            message.info(`Nomor Rekening berhasil di salin.`);
                                            navigator.clipboard.writeText(
                                                paymentResultRyFlip?.data?.data?.account_number ?? ""
                                            );
                                        }}>
                                        Salin Nomor Rekening
                                    </a>
                                </div>
                            </Card>
                        ) : null}
                    </>
                ) : (
                    <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description={paymentResultRyFlip?.data?.message}
                    />
                )}
            </Skeleton>

            <Card hoverable title={"Flip"} style={{ marginBottom: 10 }}>
                <span className="transaction-detail-text">Link Pembayaran (Flip)</span>
                <span className="transaction-detail-description">
                    <a
                        href={paymentResultRyFlip?.data?.data?.payment_url}
                        target="_blank"
                        rel="noreferrer">
                        Klik link ini untuk membayar melalui Flip
                    </a>
                </span>
            </Card>

            <Card hoverable title={"Detail Transaksi"} style={{ marginBottom: 10 }}>
                <span className="transaction-detail-text">Nama Transaksi</span>
                <span className="transaction-detail-description">Topup Wallet</span>
            </Card>

            {channel?.hows && channel.hows.length > 0 ? (
                <Card hoverable title={"Cara Pembayaran"} style={{ marginBottom: 10 }}>
                    <Tabs>
                        {channel.hows.map((item, index) => (
                            <Tabs.TabPane tab={item.name} key={index}>
                                {item.steps?.map((step, stepIndex) => (
                                    <p key={stepIndex}>
                                        {stepIndex + 1}. {step}
                                    </p>
                                ))}
                            </Tabs.TabPane>
                        ))}
                    </Tabs>
                </Card>
            ) : null}
        </div>
    );
}

export default PaymentRyFlipTopupV2;
